var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-block vs-con-loading__container",class:{
    '_cover': _vm.cover,
    '_small': _vm.small
  },attrs:{"id":("loader-block-" + _vm.name)}},[(_vm.hasDefaultSlot)?_vm._t("default"):_c('div',[(!_vm.small)?_c('h6',{staticClass:"text-primary mt-32"},[_vm._v("Loading")]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }